// PDF rendering and its controls belong to the browser's native viewer.
// The link also works on browsers that hand PDFs to a separate app.
export function pdfView(url,title){
  const view=document.createElement('div');view.className='native-pdf';
  const frame=document.createElement('iframe');frame.title=title;frame.src=url;frame.className='native-pdf-frame';
  const link=document.createElement('a');link.href=url;link.target='_blank';link.rel='noopener';link.textContent='PDF ↗';link.className='native-pdf-link';
  view.append(frame,link);return view;
}
